import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'

const WorkspaceFormManualDuration = ({ manualDuration, onChange }) => (
  <WorkspaceFormInput attribute='manualDuration'>
    <input
      type='number'
      className='workspace-form__input'
      value={manualDuration || ''}
      onChange={(e) => onChange({ manualDuration: e.target.value ? Number(e.target.value) : null })}
    />
  </WorkspaceFormInput>
)

WorkspaceFormManualDuration.propTypes = {
  manualDuration: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  manualDuration: state.form.data.manualDuration
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormManualDuration)
